import { startTransition, useEffect } from "react";

import { FieldValues, UseFormReturn } from "react-hook-form";

import { useLatestRef } from "../useLatestRef";

export const usePreviewFormWatch = <T extends FieldValues>(form: UseFormReturn<T>, syncPreview: () => void) => {
  const syncPreviewRef = useLatestRef(syncPreview);

  useEffect(() => {
    const subscription = form.watch(() => startTransition(() => syncPreviewRef.current()));

    return () => subscription.unsubscribe();
  }, [form, syncPreviewRef]);
};
